
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, switchMap } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { DispatchSearch } from '../DispatchSearch';
import { v_DispatchSearchBus } from '../models/v_DispatchSearchBus';
import { FileInfo } from '@progress/kendo-angular-upload';
import { AttachmentBus } from '../models/AttachmentBus';
import { SearchTarget } from '../enums/SearchTarget';
import { CommonParam } from '../models/CommonParam';
import { CommonFunctions } from '../static/common-functions';
import { PdfResponse } from '../models/PdfResponse';
import { InvoiceNumberCheckResponse } from '../models/InvoiceNumberCheckResponse';

@Injectable()
export class InvoiceService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Invoice/";
    }
    get(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + Id;
        return super.get(url_call);
    }

    getTaxCode(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetTaxCode/" + id;
        return super.get(url_call);
    }
    createCreditMemoCRZuggit(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateCreditMemoCRZuggit/" + id;
        return super.get(url_call);
    }
    getAdditionalData(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalData/" + id;
        return super.get(url_call).pipe(switchMap((data: any) => {
            if (data && data.lineItems && data.lineItems.length > 0) {
                data.lineItems.forEach(li => {
                    if (li.markup < 0) {
                        li.markup = 0; // Ensure no negative markup
                    }
                });
            }
            return of(data);
        }));
    }
    getAdditionalDataCL(id: string, cusId: any, locId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalDataCL/" + id + "/" + cusId + "/" + locId;
        return super.get(url_call);
    }
    //GetLineItemsViewForSplit
    getLineItemsViewForSplit(id: any, code: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLineItemsViewForSplit/" + id + '/' + code;
        return super.get(url_call);
    }
    getLineItemsViewForCMOrCORR(id: any, code: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLineItemsViewForCMOrCORR/" + id + '/' + code;
        return super.get(url_call);
    }
    getLineItemsView(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetLineItemsView/" + id;
        return super.get(url_call);
    }
    getEmailDefaultsForBilling(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEmailDefaultsForBilling/" + id;
        return super.get(url_call);
    }
    getScheduledInvoices(): Observable<any> {
        let url_call: string = this.baseUrl + "GetScheduledInvoices/";
        return super.get(url_call);
    }
    saveScheduledInvoices(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveScheduledInvoices";
        return this._http.put(url_call, model, { headers });
    }
    saveCollectionNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CollectionNote_Save";
        return this._http.put(url_call, model, { headers });
    }
    duplicateInvoice(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DuplicateInvoice/" + id;
        return super.get(url_call);
    }
    getRoundysInvoices(): Observable<any> {
        let url_call: string = this.baseUrl + "GetRoundysInvoices";
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    getGFSInvoices(): Observable<any> {
        let url_call: string = this.baseUrl + "GetGFSInvoices";
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    getCorrigoInvoices(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCorrigoInvoices/" + id;
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    getServiceChannelInvoices(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetServiceChannelInvoices/" + id;
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    getCostcoInvoices(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCostcoInvoices/" + id;
        return super.getWithResponseType(url_call, 'arraybuffer');
    }
    mergeDocs(id: string): Observable<any> {
        let url_call: string = this.baseUrlCPConn + "MergeDocs/" + id;
        return super.get(url_call);
    }
    getFromNumber(number: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetFromNumber/" + number;
        return super.get(url_call);
    }
    getAttachments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAttachments/" + id;
        return super.get(url_call);
    }
    getDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDocument/" + id;
        return super.get(url_call);
    }
    getInvoiceEquipment(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoiceEquipment/" + id;
        return super.get(url_call);
    }
    getStatusHistory(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetStatusHistory/" + id;
        return super.get(url_call);
    }
    getCollectionNotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCollectionNotes/" + id;
        return super.get(url_call);
    }
    getChecklist(id: string, customerId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoiceCheckList/" + id + "/" + customerId;
        return super.get(url_call);
    }
    getAdditionalDataWithCustomerLocation(customerId: string, locationId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalDataWithCustomerLocation/" + customerId + "/" + locationId;
        return super.get(url_call);
    }

    getInvoiceDefaultsFromLocation(id: string, dispatchId: string, isFromDraw: boolean = false): Observable<any> {
        if (dispatchId && CommonFunctions.hasGuidValue(dispatchId)) {
            let url_call: string = this.baseUrl + "GetInvoiceDefaultsFromLocation/" + id + "/" + isFromDraw + "/" + dispatchId;
            return super.get(url_call);
        }
        return of(null);
    }
    getLineItemHistory(invoiceId: string, invoiceLineId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLineItemHistory/" + invoiceId + "/" + invoiceLineId;
        return super.get(url_call);
    }
    getAllLineItemHistory(invoiceId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAllLineItemHistory/" + invoiceId;
        return super.get(url_call);
    }
    savePrimary(userId: any, model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAndReturn/" + userId;
        return this._http.put(url_call, model, { headers });
    }
    saveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAll";
        return this._http.put(url_call, model, { headers });
    }
    copyLinesToNewInvoice(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CopyLinesToNewInvoice";
        return this._http.put(url_call, model, { headers });
    }
    getPricingProjection(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetPricingProjection";
        return this._http.put(url_call, model, { headers });
    }
    saveCreditMemoOrCORR(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveCreditMemoOrCORR";
        return this._http.put(url_call, model, { headers });
    }
    saveInvoiceLine(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInvoiceLine";
        return this._http.put(url_call, model, { headers });
    }
    saveInvoiceLinesPricingAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInvoiceLinesPricingAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveInvoiceNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInvoiceNote";
        return this._http.put(url_call, model, { headers });
    }
    deleteInvoiceLine(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteInvoiceLine/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteInvoiceAttachment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteInvoiceAttachment/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteInvoice(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteInvoice/" + id;
        return this._http.delete(url_call, { headers });
    }
    printPDFInvoice(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "PrintPDFInvoice/" + id;
        return super.get(url_call);
    }
    print(id: any): Observable<any> {
        let url_call: string = this.baseUrlCPConn + "PrintInvoice/" + id;
        return super.get(url_call);
    }
    //calls 2.2 new pdf engine endpoint
    printUsingIronPdf(id: string): Observable<PdfResponse> {
        let url: string = this.baseUrl + id + "/pdf";
        return super.get(url);
    }
    createInvoiceFrom(fromTarget: SearchTarget, id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateInvoiceFrom/" + fromTarget + "/" + id;
        return super.get(url_call);
    }
    dispatchInvoiceEstimate(fromTarget: SearchTarget, id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DispatchInvoiceEstimate/" + fromTarget + "/" + id;
        return super.get(url_call);
    }
    createInvoiceLineFrom(fromTarget: SearchTarget, id: string, detailType: number, detailId: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateInvoiceLineFrom/" + fromTarget + "/" + id + "/" + detailType + "/" + detailId;
        return super.get(url_call);
    }
    dispatchRefTrackingNbr_Update(dispatchId: string, refTrackNbr: string): Observable<any> {
        let url_call: string = this.baseUrl + "DispatchRefTrackingNbr_Update/" + dispatchId + "/" + refTrackNbr;
        return super.get(url_call);
    }
    saveInvoiceEquipment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInvoiceEquipment";
        return this._http.put(url_call, model, { headers });
    }
    deleteInvoiceEquipment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteInvoiceEquipment/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteNote(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteNote/" + id;
        return this._http.delete(url_call, { headers });
    }
    getInventoryLine(model: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetInventoryLine";
        return this._http.put(url_call, model, { headers });
    }
    getInvoicePayments(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoicePayments/" + id;
        return super.get(url_call);
    }
    saveInvoicePayment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInvoicePayment";
        return this._http.put(url_call, model, { headers });
    }
    deleteInvoicePayment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteInvoicePayment/" + id;
        return this._http.delete(url_call, { headers });
    }
    getListFromMaster(masterId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetListFromMaster/" + masterId;
        return super.get(url_call);
    }
    invoiceLineShowDispatch(model: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "InvoiceLineShowDispatch";
        return this._http.get(url_call, options);
    }

    uploadAttachment(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "UploadAttachment";
        const formData = new FormData();
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", JSON.stringify(data));

        return this._http.put(url, formData);
    }

    checkForDuplicatePO(model: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "CheckForDuplicatePO";
        return this._http.get(url_call, options);
    }
    checkInvoiceWithSuffix(invoiceNumbers: string[]): Observable<InvoiceNumberCheckResponse> {
        if (!invoiceNumbers || invoiceNumbers.length === 0) {
            return of();
        }
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CheckInvoicesWithSuffix";
        return this._http.post(url_call, invoiceNumbers, { headers });
    }
    importCollectionNotes(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "ImportCollectionNotes";
        const formData = new FormData();
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", JSON.stringify(data));

        return this._http.put(url, formData);
    }
    getSetPartPrice(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "GetSetPartPrice";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    saveInvoiceDisputeStatus(id: any, param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "SaveInvoiceDisputeStatus/" + id;
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }

    saveInvoiceDisputeCMReq(id: any, param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "SaveInvoiceDisputeCMReq/" + id;
        let headers = this.getHeaders();
        return this._http.put(url_call, param, { headers });
    }
    createCreditMemoCR(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "CreateCreditMemoCR";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    createCreditMemoAndCORR(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "CreateCreditMemoAndCORR";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    getRelatedInvoices(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetRelatedInvoices/" + id;
        return super.get(url_call);
    }

    importInvoiceStatusChange(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "ImportInvoiceStatus";
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", JSON.stringify(data));

        return this._http.put(url, formData);
    }

    createTransaction(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "AvalaraCreateTransaction/" + id;
        return this._http.post(url_call, null, { headers: headers });
    }

    updateTransaction(details: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "AvalaraUpdateTransaction";
        return this._http.post(url_call, details, { headers: headers });
    }

    commitTransaction(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "AvalaraCommitTransaction/" + id;
        return this._http.post(url_call, null, { headers: headers });
    }

    deleteTransaction(id: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "AvalaraVoidTransaction/" + id;
        return this._http.post(url_call, null, { headers: headers });
    }

    getAvalaraTaxStatus(id: string) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetAvalaraTaxStatus/" + id;
        return this._http.get(url_call, { headers });
    }

    getAvalaraTaxRate(id: string) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "GetAvalaraTaxRate/" + id;
        return this._http.get(url_call, { headers });
    }

    specialProcess(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "SpecialProcess";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    createScheduledInvoices(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "CreateScheduledInvoices";
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    createScheduledInvoicesFromQR(model: CommonParam): Observable<any> {
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "CreateScheduledInvoicesFromQR";
        return this._http.get(url_call, options);
    }
    createScheduledInvoiceFromId(model: CommonParam): Observable<any> {
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "CreateScheduledInvoiceFromId";
        return this._http.get(url_call, options);
    }
    createScheduledInvoicesQR(model: CommonParam): Observable<any> {
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "CreateScheduledInvoicesQR";
        return this._http.get(url_call, options);
    }
    createInvoicePdf(id: string) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CreateInvoicePdf/" + id;
        return this._http.get(url_call, { headers });
    }
    updateInvoiceForTesting(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "UpdateInvoiceForTesting/" + id;
        return super.get(url_call);
    }
    updateInvoiceStatus(invoiceId: any, statusId: any): Observable<any> {
        let url_call: string = this.rootUrl_v2 + "Receivables/set-status/" + invoiceId + "/" + statusId;
        return super.get(url_call);
    }

    doScheduledInvoicing(): Observable<any> {
        let url_call: string = this.baseUrl + "DoScheduledInvoicing";
        return super.get(url_call);
    }

    resendOracle(invoiceId: any): Observable<any> {
        let options = this.getOptionsUL('', '');
        let url_call: string = this.rootUrl_v2 + "Receivables/oic/create/" + invoiceId;
        var s_search = JSON.stringify(invoiceId);
        return this._http.post(url_call, s_search, options);

    }
    resendOracleIntercompany(invoiceId: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "oic/intercompany/" + invoiceId;
        return this._http.post(url_call, null, { headers: headers });
    }
    createNewInvoiceFrom(from: SearchTarget, id: any): Observable<any> {
        let url_call: string = this.baseUrl + "CreateInvoiceFrom/" + from + "/" + id;
        return super.get(url_call);
    }

}
